/* raw layout hash: _default-web-layout-1r2bgmj:9c3298d3be26a4c458c27f41ec48cc57d00c7b07639b1a8962807d075717b097 */
import React from 'react';
import { Outlet } from 'react-router-dom';
import AppNavbar from './nav/AppNavbar.jsx';
import AppFooter from './nav/AppFooter.jsx';

/**
 * Default authenticated web shell — RawHTMLDesign/layouts/_default-web-layout-1r2bgmj.html.
 * A distinct raw layout capture of the same default web shell (identical
 * navbar/menu/footer chrome to _default-web-layout), so its structure is
 * built from the same shared AppNavbar/AppFooter sub-components rather than
 * duplicated markup. Reused by every page whose page_layout node is
 * "_default-web-layout-1r2bgmj".
 */
export default function DefaultWebLayoutAlt2() {
  return (
    <div className="app-shell-web">
      <AppNavbar />

      <main>
        <Outlet />
      </main>

      <AppFooter />
    </div>
  );
}
